import React from 'react';
import { Container, Section } from './Progress.styles';

export interface ProgressProps {
  value: number;
  width?: number;
}

export default function Progress({ value, width = 41 }: ProgressProps) {
  return (
    <Container $width={width}>
      <Section $value={value} $parentWidth={width} />
    </Container>
  );
}
